import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
window.axios.defaults.withXSRFToken = true;

import _ from 'lodash';
window._ = _;

import swal from 'sweetalert'
swal.setDefaults({
  showCloseButton: true,
  closeOnClickOutside: false,
})
window.swal = swal

String.prototype.toTitleCase = function () {
  let str = this.trim();

  if (str.length === 0) {
    return '';
  }

  // Replace common delimiters (hyphens, underscores) with spaces
  // and then add a space before uppercase letters for PascalCase/camelCase handling
  // This allows for a single split operation later.
  str = str.replace(/[-_]/g, ' ') // Replace hyphens and underscores with spaces
    .replace(/([A-Z])/g, ' $1'); // Add a space before uppercase letters

  // Split by one or more spaces, filtering out empty strings from multiple spaces
  const words = str.split(/\s+/).filter(word => word.length > 0);

  // Capitalize the first letter of each word and lowercase the rest
  const titleCasedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  // Join the words back together with a single space
  return titleCasedWords.join(' ');
};

function showSwal(message, timer) {
  swal(message, {
    buttons: [false, true],
    timer: timer,
    icon: 'success',
  })
}

window.swalUpdated = function (message = 'Updated', timer = 3000) {
  showSwal(message, timer)
}

window.swalDeleted = function (message = 'Deleted', timer = 3000) {
  showSwal(message, timer)
}
